import { render, staticRenderFns } from "./create-group.html?vue&type=template&id=83028a4e&scoped=true&external"
import script from "./create-group.js?vue&type=script&lang=js&external"
export * from "./create-group.js?vue&type=script&lang=js&external"
import style0 from "./create-group.scss?vue&type=style&index=0&id=83028a4e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83028a4e",
  null
  
)

export default component.exports